import { BaseQueryFn } from '@reduxjs/toolkit/dist/query';
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
  build.mutation<NewPhone, NewPhone>({
    query: (credentials) => ({
      url: '/partner-user/current/change-phone-number-request-for-unverified',
      method: 'POST',
      body: credentials,
    }),
  });

export type NewPhone = {
  phoneNumber: string;
  phoneNumberCountryCode: string;
};
